import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
  Box,
  Button,
  Grid,
  Card,
  Tooltip,
  Autocomplete,
  Chip,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { IShopReportParam, ShopLocation } from 'src/@types/Choqorak/MainTables/Shop/Shop';
import Moveable from 'react-moveable';
import { useStore } from 'src/stores/store';
import { Controller, useForm } from 'react-hook-form';
import LocalizDatePicker from 'src/sections/common/LocalizDatePicker';
import useLocales from 'src/hooks/useLocales';
import Iconify from 'src/components/Iconify';
import { useNavigate } from 'react-router';
import { storeIdToLocalStorage } from 'src/Common/storeIdToLocalStorage';
import { PATH_DASHBOARD } from 'src/routes/paths';
import InfoIcon from '@mui/icons-material/Info';
import Label from 'src/components/Label';
import Loader from 'src/components/loader/Loader';
import { baseUrl } from 'src/api/baseUrl';
import { useReactToPrint } from 'react-to-print';

export default observer(function ChoqoralMap() {
  const { translate } = useLocales();
  const {
    ShopStore,
    ChoqorakCommonDropdown,
    ContractInfoStore,
    RentPaymentStore,
    ElectricityPaymentStore,
    FloorStore,
  } = useStore();
  const { ShopForMapResult, updateShopLocation, loadShopForMap, loadShopDetail } = ShopStore;
  const { loadFloorDetail, selectedFloorDetail } = FloorStore;
  const { GetHistory } = ContractInfoStore;
  const { GetRentPaymentHistory } = RentPaymentStore;
  const { GetElectricityPaymentHistory } = ElectricityPaymentStore;
  const {
    loadBlockeDDL,
    BlockOption,
    loadFloorDDL,
    FloorOption,
    loadShopTypeDDL,
    ShopTypeOption,
    loadStatusDDL,
    StatusOption,
  } = ChoqorakCommonDropdown;
  const navigate = useNavigate();
  const [year, setYear] = useState<string>(''); // State for the year
  const [month, setMonth] = useState<string>(''); // State for the year
  const [floor, setFloor] = useState();
  const [block, setBlock] = useState();
  const [status, setStatus] = useState();
  const [shopType, setShoptype] = useState();
  const [editMode, setEditMode] = useState(false);
  const [modifiedShop, setModifiedShop] = useState<ShopLocation | null>(null);
  const [load, setLoad] = useState<boolean>(true);
  // Create refs for each shop element
  const shopRefs = useRef<{ [key: number]: React.RefObject<HTMLDivElement> }>({});

  const defaultValues = useMemo<IShopReportParam>(
    () => ({
      year: new Date(),
    }),
    []
  );
  const methods = useForm<IShopReportParam>({
    defaultValues,
  });
  const { watch, control, setValue } = methods;

  const fromDate = watch('year');
  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };
  // console.log(modifiedShop);
  const handleSaveShopLocation = () => {
    console.log(modifiedShop);
    if (modifiedShop) {
      // Call the updateShopLocation function to save the modified shop
      updateShopLocation({
        shopId: modifiedShop.shopId,
        shopXLocation: modifiedShop.shopXLocation,
        shopYLocation: modifiedShop.shopYLocation,
        shopRotationDigree: modifiedShop.shopRotationDigree,
        shopXSize: modifiedShop.shopXSize,
        shopYSize: modifiedShop.shopYSize,
      }).then(() => {
        loadShopForMap({
          year: Number(year),
          month: Number(month),
          floorId: floor,
          blockId: block,
          // shopStatusId: status,
          shopTypeId: shopType,
        });
      });
    }
  };

  //#region Search Bard
  useEffect(() => {
    loadBlockeDDL();
    loadFloorDDL();
    loadShopTypeDDL();
    loadStatusDDL(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue]);

  useEffect(() => {
    if (fromDate) {
      const changeDateToDateFormat = new Date(fromDate);

      // Extract Persian year and month
      const persianYear = changeDateToDateFormat.toLocaleString('fa-IR-u-ca-persian', {
        year: 'numeric',
      });
      const persianMonth = changeDateToDateFormat.toLocaleString('fa-IR-u-ca-persian', {
        month: 'numeric',
      });

      // Convert Persian numerals to Western numerals
      const westernYear = persianYear.replace(/[۰-۹]/g, (digit) =>
        '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit).toString()
      );
      const westernMonth = persianMonth.replace(/[۰-۹]/g, (digit) =>
        '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit).toString()
      );

      // Update state with Western year and month
      setYear(westernYear);
      setMonth(westernMonth);
    }
  }, [fromDate]);

  const Search = async (e: any) => {
    e.preventDefault();
    // setIsloading(true);
    if (floor && FloorOption.length > 0) {
      // Ensure FloorOption exists
      setLoad(true);
      loadFloorDetail(floor).then(() => {
        // Ensure it's a number
        loadShopForMap({
          year: Number(year),
          month: Number(month),
          floorId: floor,
          blockId: block,
          // shopStatusId: status,
          shopTypeId: shopType,
        }).then(() => {
          setLoad(false);
        });
      });
    }

    // .then((res) => {
    //   setIsloading(false);
    // })
    // .catch((err) => {
    //   setIsloading(false);
    // });
  };
  //#endregion

  useEffect(() => { }, [editMode]);
  useEffect(() => { }, [floor]);

  useEffect(() => { }, [ShopForMapResult]);
  let Url = baseUrl;
  const mapRef = useRef<HTMLImageElement>(null);
  const [mapSize, setMapSize] = useState({ width: 1, height: 1 });
  useEffect(() => {
    const updateMapSize = () => {
      if (mapRef.current) {
        const rect = mapRef.current.getBoundingClientRect();
        setMapSize({ width: rect.width, height: rect.height });
      }
    };

    updateMapSize();
    window.addEventListener('resize', updateMapSize);
    return () => window.removeEventListener('resize', updateMapSize);
  }, []);
  // console.log(Url + selectedFloorDetail?.attachmentPath);


  const PrintRef = useRef<HTMLDivElement>(null)
  const handlePrint = useReactToPrint({
    content: () => PrintRef.current,
  });
  return (
    <Grid container>
      {/* Filter Section */}
      <Grid item xs={12}>
        <Card sx={{ padding: '30px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} spacing={2}>
              <Card
                sx={{
                  p: 3,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center', // Use justifyContent instead of justifyItems
                }}
              >
                <Grid item xs={12} md={12}>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 2,
                      rowGap: 3,
                      gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(7, 1fr)' },
                    }}
                  >
                    <LocalizDatePicker
                      name="year"
                      label={translate('Report.FromDate')}
                      control={control}
                      size={'small'}
                      views={['year', 'month']}
                    />

                    <Controller
                      name="blockId"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                          fullWidth
                          freeSolo
                          onChange={(event, newValue) => setBlock(newValue.value)}
                          options={BlockOption.map((option: any) => option)}
                          value={field.value}
                          getOptionLabel={(option) => option.text}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                {...getTagProps({ index })}
                                key={option.value}
                                size="small"
                                label={option.value}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={translate('ShopReport.Block')}
                              error={!!error}
                              size="small"
                              helperText={error?.message}
                            />
                          )}
                        />
                      )}
                    />

                    <Controller
                      name="floorId"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                          fullWidth
                          freeSolo
                          onChange={(event, newValue) => setFloor(newValue.value)}
                          options={FloorOption.map((option: any) => option)}
                          value={field.value}
                          getOptionLabel={(option) => option.text}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                {...getTagProps({ index })}
                                key={option.value}
                                size="small"
                                label={option.value}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={translate('ShopReport.Floor')}
                              error={!!error}
                              size="small"
                              helperText={error?.message}
                            />
                          )}
                        />
                      )}
                    />

                    <Controller
                      name="shopTypeId"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                          fullWidth
                          freeSolo
                          onChange={(event, newValue) => setShoptype(newValue.value)}
                          options={ShopTypeOption.map((option: any) => option)}
                          value={field.value}
                          getOptionLabel={(option) => option.text}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                {...getTagProps({ index })}
                                key={option.value}
                                size="small"
                                label={option.value}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={translate('ShopReport.ShopType')}
                              error={!!error}
                              size="small"
                              helperText={error?.message}
                            />
                          )}
                        />
                      )}
                    />

                    {/* <Controller
                      name="shopStatusId"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                          fullWidth
                          freeSolo
                          onChange={(event, newValue) => setStatus(newValue.value)}
                          options={StatusOption.map((option: any) => option)}
                          value={field.value}
                          getOptionLabel={(option) => option.text}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                {...getTagProps({ index })}
                                key={option.value}
                                size="small"
                                label={option.value}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={translate('ShopReport.Status')}
                              error={!!error}
                              size="small"
                              helperText={error?.message}
                            />
                          )}
                        />
                      )}
                    /> */}
                    <Button
                      sx={{ width: '120px' }}
                      variant="contained"
                      onClick={Search}
                      startIcon={<Iconify icon="eva:search-fill" />}
                    >
                      {translate('ShopReport.Filter')}
                    </Button>

                    <Button
                      sx={{ width: '120px' }}
                      variant="contained"
                      color="success"
                      onClick={toggleEditMode}
                      startIcon={<Iconify icon="eva:edit-fill" />}
                    >
                      {/* {translate('Attendance.Filter')} */}
                      {editMode ? translate('Shop.Done') : translate('Shop.Edit')}
                    </Button>

                    <Button
                      sx={{ width: '120px' }}
                      variant="contained"
                      color="warning"
                      onClick={handlePrint}
                      startIcon={<Iconify icon="eva:print-fill" />}
                    >
                      {/* {translate('Attendance.Filter')} */}
                      {translate('Report.Print')}
                    </Button>
                  </Box>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      {/* Map Section */}
      <Grid item xs={12} >
        <div ref={PrintRef}>
          <div
            ref={mapRef}
            style={{
              width: '2000px', // fixed width
              height: '1414px',
              aspectRatio: '16 / 9', // یا height: '100vh' در صورت نیاز
              backgroundImage: `url(
            ${selectedFloorDetail?.attachmentPath
                  ? Url + selectedFloorDetail.attachmentPath
                  : '/Images/basement_map_wider.jpg'
                })`,
              // backgroundImage: `url(

              //       /Images/basement_map_wider.jpg
              //   )`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-Repeat',
              // border: '1px solid #ccc',
              position: 'relative',
            }}
          >
            {/* Background Map */}
            {/* {load ? (
                  <Loader />
                ) : ( */}

            {/* )} */}
            {(ShopForMapResult ?? []).map((shop: any) => {
              if (!shopRefs.current[shop.shopId]) {
                shopRefs.current[shop.shopId] = React.createRef();
              }

              return (
                <div key={shop.shopId}>
                  <Tooltip
                    title={
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <strong>{translate('Shop.ShopCode')}</strong>
                            </TableCell>
                            <TableCell>{shop.shopCode}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <strong>{translate('ElectricMeter.ElectricMeterSerial')}</strong>
                            </TableCell>
                            <TableCell>{shop.electricMeterSerial}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <strong>{translate('Shop.ShopType')}</strong>
                            </TableCell>
                            <TableCell>{shop.shopType}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <strong>{translate('Shop.ShopArea')}</strong>
                            </TableCell>
                            <TableCell>{shop.shopLength}*{shop.shopWidth}</TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>
                              <strong>{translate('Shop.RentPerMonth')}</strong>
                            </TableCell>
                            <TableCell>
                              {shop.rentPerMonth} {shop.rentCarrencyName}
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>
                              <strong>{translate('Shop.ShopStatus')}</strong>
                            </TableCell>
                            <TableCell>{shop.shopStatus}</TableCell>
                          </TableRow>
                          {shop.hasContract ? (
                            <>
                              <TableRow>
                                <TableCell>
                                  <strong>{translate('Customer.CustomerName')}</strong>
                                </TableCell>
                                <TableCell>{shop.customerName}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <strong>{translate('RentPayment.Title')}</strong>
                                </TableCell>
                                <TableCell>
                                  {shop.rentPayment.haspaid ? (
                                    <Label color="success">{translate('RentPayment.Paid')}</Label>
                                  ) : (
                                    <Label color="warning">{translate('RentPayment.UnPaid')}</Label>
                                  )}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <strong>{translate('ElectricityPayment.Title')}</strong>
                                </TableCell>
                                <TableCell>
                                  {shop.ectricityPayment.haspaid ? (
                                    <Label color="success">{translate('RentPayment.Paid')}</Label>
                                  ) : (
                                    <Label color="warning">{translate('RentPayment.UnPaid')}</Label>
                                  )}
                                </TableCell>
                              </TableRow>
                            </>
                          ) : (
                            ''
                          )}
                          <TableRow>
                            <TableCell colSpan={2} align="center">
                              <IconButton
                                color="primary"
                                size="small"
                                onClick={() => {
                                  storeIdToLocalStorage(shop.shopId, ShopStore);
                                  loadShopDetail(shop.shopId).then(() => {
                                    GetElectricityPaymentHistory({ shopId: shop.shopId });
                                    GetRentPaymentHistory({ shopId: shop.shopId });
                                    GetHistory({ shopId: shop.shopId });
                                    navigate(PATH_DASHBOARD.Shop.detail);
                                  });
                                }}
                              >
                                <InfoIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    }
                    arrow

                  >
                    <div
                      className="target"
                      id={`shop-${shop.shopId}`}
                      ref={shopRefs.current[shop.shopId]}
                      style={{
                        position: 'absolute',
                        width: `${shop.shopXSize}px`,
                        height: `${shop.shopYSize}px`,
                        left: `${shop.shopXLocation}px`,
                        top: `${shop.shopYLocation}px`,
                        transform: `rotate(${shop.shopRotationDigree}deg)`,
                        background: `${shop.shopStatusId === 7 && shop.hasContract
                          ? 'linear-gradient(to right, green, gray)' // Green gradient for Rented
                          : shop.shopStatusId === 9
                            ? 'linear-gradient(to right, blue, skyblue)' // Blue gradient for Maintenance
                            : shop.contractStatusId === 6 ? 'linear-gradient(to right,  rgb(235, 235, 104), rgb(79, 79, 31))' 
                            : 'linear-gradient(to right,  rgb(255, 255, 255), rgb(79, 79, 31))' 
                          }`,

                        textAlign: 'center',
                        padding: '5px',
                        fontSize: 'clamp(8px, 0.6vw, 18px)',
                        overflow: 'hidden',
                        border: `${shop.shopStatus === 'Rented' &&
                          shop.hasContract &&
                          (shop.rentPayment.haspaid === false ||
                            shop.ectricityPayment.haspaid === false)
                          ? '2px solid red' // Green gradient for Rented
                          : // Blue gradient for Maintenance
                          '' // Red gradient for others
                          }`,
                        fontWeight: 'bold',
                        borderRadius: '10px',
                        color: 'black'
                      }}
                    >
                      {shop.shopCode}
                    </div>
                  </Tooltip>
                  {editMode ? (
                    <Moveable
                      target={shopRefs.current[shop.shopId]?.current}
                      draggable={editMode} // Enable only if edit mode is ON
                      resizable={editMode}
                      rotatable={editMode}
                      // hideDefaultLines={editMode}
                      onDrag={({ target, left, top }) => {
                        target.style.left = `${left}px`; // Update left position directly
                        target.style.top = `${top}px`; // Update top position directly
                        target.style.transform = `rotate(${shop.shopRotationDigree}deg)`; // Fix rotation

                        setModifiedShop({
                          shopId: shop.shopId,
                          shopXLocation: left,
                          shopYLocation: top,
                          shopRotationDigree: shop.shopRotationDigree,
                          shopXSize: shop.shopXSize,
                          shopYSize: shop.shopYSize,
                        });
                      }}
                      onResize={({ target, width, height }) => {
                        target.style.width = `${width}px`;
                        target.style.height = `${height}px`;

                        setModifiedShop({
                          shopId: shop.shopId,
                          shopXLocation: shop.shopXLocation,
                          shopYLocation: shop.shopYLocation,
                          shopRotationDigree: shop.shopRotationDigree,
                          shopXSize: width,
                          shopYSize: height,
                        });
                      }}
                      onRotate={({ target, beforeRotate }) => {
                        target.style.transform = `rotate(${beforeRotate}deg)`; // Apply rotation

                        setModifiedShop({
                          shopId: shop.shopId,
                          shopXLocation: shop.shopXLocation,
                          shopYLocation: shop.shopYLocation,
                          shopRotationDigree: beforeRotate, // Update rotation degree
                          shopXSize: shop.shopXSize,
                          shopYSize: shop.shopYSize,
                        });
                      }}
                      onDragEnd={handleSaveShopLocation}
                      onResizeEnd={handleSaveShopLocation}
                      onRotateEnd={handleSaveShopLocation}
                    />
                  ) : (
                    ''
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Grid>
    </Grid>
  );
});
